import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as d, d as u } from "./constants-CnFYFetN.mjs";
const h = p()((a, s) => {
  const { borderRadiuses: r, constructs: t, mode: e, palette: o } = a, { current: c, height: n, total: l, width: g } = s;
  return {
    innerBar: {
      background: e === d.Dye ? u.main : i.ifFeature(
        "encore",
        t.surface.primary.strong,
        `linear-gradient(to right, ${o.primary.lightest}, ${o.primary.lighter})`
      ),
      borderRadius: i.ifFeature("encore", r[1e3], 6),
      height: `${n}px`,
      maxWidth: "100%",
      width: `${100 * c / l}%`
    },
    outerBar: {
      backgroundColor: e === d.Dye ? u.lightest : o.gray[200],
      borderRadius: i.ifFeature("encore", r[1e3], 6),
      height: `${n}px`,
      width: g
    }
  };
}), B = ({ current: a, height: s = 12, total: r, width: t = "100%" }) => {
  const { classes: e } = h({ current: a, height: s, total: r, width: t });
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      "aria-label": "progress-bar",
      "aria-valuemax": r,
      "aria-valuemin": 0,
      "aria-valuenow": a,
      className: e.outerBar,
      "data-fabric-component": "ProgressBar",
      role: "progressbar",
      children: /* @__PURE__ */ m.jsx("div", { className: e.innerBar })
    }
  );
};
export {
  B as P
};
//# sourceMappingURL=progress-bar-RdhhxBEI.mjs.map
